import { render, staticRenderFns } from "./Cert.vue?vue&type=template&id=e2de679c&scoped=true"
import script from "./Cert.vue?vue&type=script&lang=js"
export * from "./Cert.vue?vue&type=script&lang=js"
import style0 from "./Cert.vue?vue&type=style&index=0&id=e2de679c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2de679c",
  null
  
)

export default component.exports